module.exports = __webpack_public_path__ + "img/getcheeLog-m.59098b30.svg";